import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

import { FormController } from '@/ui-lib/form/form-controller';
import { renderTextInput } from '@/ui-lib/form/form-input-renders';

import { SelectedPrice } from './types';

const emailSchema = z.object({
    email: z.string().email('Please enter a valid email address'),
});

const selectedReportsSchema = z.object({
    selectedPrices: z.record(
        z.string(),
        z.object({
            priceId: z.number(),
            type: z.enum(['group']),
        })
    ),
});

export type EmailFormData = z.infer<typeof emailSchema>;
export type SelectedReportsFormData = z.infer<typeof selectedReportsSchema>;

export function useCheckoutEmailForm(defaultEmail?: string) {
    return useForm<EmailFormData>({
        resolver: zodResolver(emailSchema),
        defaultValues: {
            email: defaultEmail || '',
        },
    });
}

export function useSelectedReportsForm(initialData: { selectedPrices: Record<string, SelectedPrice> }) {
    return useForm<SelectedReportsFormData>({
        resolver: zodResolver(selectedReportsSchema),
        defaultValues: {
            selectedPrices: initialData.selectedPrices,
        },
        mode: 'onChange',
    });
}

export const CheckoutEmailForm = ({
    form,
    disabled,
    onEmailChange,
}: {
    form: ReturnType<typeof useCheckoutEmailForm>;
    disabled?: boolean;
    onEmailChange?: (email: string) => void;
}) => (
    <FormController
        control={form.control}
        field="email"
        renderInput={renderTextInput}
        label="Email:"
        required
        placeholder="Email"
        extraProps={{
            disabled,
            'data-lpignore': true,
            'data-1p-ignore': true,
            autoComplete: 'off',
            autoCapitalize: 'none',
            inputMode: 'email',
            onChange: onEmailChange,
        }}
        plainLabel
    />
);
